<template>
  <div>
    <h2>Projektkopie senden</h2>
    <p>
      Hier senden Sie eine Kopie des Projekts per E-Mail an eine andere Person. Oben wird angezeigt,
      welches Projekt kopiert und gesendet wird. Die empfangende Person erhält eine eigene, unabhängige Kopie des
      Projekts; Ihr eigenes Projekt bleibt unverändert.
    </p>
    <p>Folgende Funktionen sind hier vorhanden:</p>
    <ul>
      <li>Empfänger-E-Mail eingeben.</li>
      <li>Projektkopie senden.</li>
      <li>Vorgang abbrechen und zum Projekt zurückkehren.</li>
    </ul>

    <v-expansion-panels accordion class="mt-5">
      <v-expansion-panel>
        <v-expansion-panel-title>
          <div class="heading">Zusätzliche Informationen</div>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <dl>
            <dt><strong>Empfänger-E-Mail:</strong></dt>
            <dd>
              Geben Sie die E-Mail-Adresse der Person ein, die die Projektkopie erhalten soll. Die
              Adresse muss gültig sein; erst dann wird die Schaltfläche „Senden“ aktiv.
            </dd>
            <dt><strong>Ihre E-Mail:</strong></dt>
            <dd>
              Wird automatisch aus Ihrer Anmeldung übernommen und dient als Absender. Fehlt diese
              Angabe, melden Sie sich bitte erneut an.
            </dd>
            <dt><strong>Senden:</strong></dt>
            <dd>
              Verschickt eine Kopie des Projekts an die angegebene Empfänger-E-Mail. Bei Erfolg
              erscheint eine Bestätigung.
            </dd>
            <dt><strong>Abbrechen:</strong></dt>
            <dd>
              Bricht den Vorgang ab und kehrt zum Projekt zurück.
            </dd>
            <dt><strong>Hinweis:</strong></dt>
            <dd>
              Ein Projekt mit einer noch unfertigen Maßnahme (Entwurf) kann nicht gesendet werden.
              Schließen Sie die betreffende Maßnahme zuerst ab.
            </dd>
          </dl>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

  </div>
</template>

<script setup lang="ts">
defineOptions({
  name: "ShareProjectHelp",
});
</script>

<style scoped>
</style>
